import AlertBarAnonymousLanguage from './AlertBarAnonymousLanguage'

export default AlertBarAnonymousLanguage
// eslint-disable-next-line import/export
export * from './AlertBarAnonymousLanguage'
